webpackJsonp([18305502733126],{

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _invertTheme = __webpack_require__(12);
	
	var _invertTheme2 = _interopRequireDefault(_invertTheme);
	
	var _rebass = __webpack_require__(4);
	
	var _components = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Home = function (_React$Component) {
	  _inherits(Home, _React$Component);
	
	  function Home() {
	    _classCallCheck(this, Home);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Home.prototype.componentDidMount = function componentDidMount() {
	    this.context.setAltLanguages(undefined);
	  };
	
	  Home.prototype.render = function render() {
	    var json = undefined;
	    if (this.props.data.home.raw) {
	      json = JSON.parse(this.props.data.home.raw);
	    }
	    return _react2.default.createElement(
	      "div",
	      {
	        style: this.props.transition ? this.props.transition.style : { opacity: 0 }
	      },
	      json && _react2.default.createElement(_components.Head, { source: json.data }),
	      _react2.default.createElement(
	        _components.Main,
	        { w: "100%", bg: "white" },
	        json && _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _rebass.Box,
	            {
	              w: "100%",
	              mx: "auto",
	              pt: [137, 80],
	              px: [4, 5, 6, 8],
	              style: { maxWidth: "90em" }
	            },
	            _react2.default.createElement(
	              _rebass.Flex,
	              {
	                is: "section",
	                flexDirection: ["column", null, "row"],
	                align: "center",
	                mt: [5, 6],
	                mb: [5, 6]
	              },
	              _react2.default.createElement(
	                _rebass.Box,
	                {
	                  w: [1, null, 1 / 2],
	                  mb: [5, null, 0],
	                  mr: [0, null, 4],
	                  pr: [0, null, 4]
	                },
	                json.data.intro_heading[0] && _react2.default.createElement(_components.H2, {
	                  children: json.data.intro_heading[0].text,
	                  mb: 5,
	                  fontSize: [5, 6]
	                }),
	                json.data.intro_subheading[0] && _react2.default.createElement(_components.Text, {
	                  children: json.data.intro_subheading[0].text,
	                  fontSize: [2, 3],
	                  mb: 48
	                }),
	                json.data.intro_button_text && json.data.intro_button_link && _react2.default.createElement(_components.PrimaryButton, {
	                  children: json.data.intro_button_text,
	                  is: "a",
	                  href: json.data.intro_button_link.url
	                })
	              ),
	              _react2.default.createElement(
	                _rebass.Box,
	                { w: [1, null, 1 / 2] },
	                _react2.default.createElement(
	                  _components.GradientCard,
	                  {
	                    image: json.data.tile_1_image ? json.data.tile_1_image.half.url : ""
	                  },
	                  json.data.tile_1_small_title[0] && _react2.default.createElement(_components.H4, {
	                    children: json.data.tile_1_small_title[0].text,
	                    mb: 5
	                  }),
	                  json.data.tile_1_title[0] && _react2.default.createElement(_components.H2, {
	                    children: json.data.tile_1_title[0].text,
	                    mb: 5,
	                    fontSize: [4, 5]
	                  }),
	                  json.data.tile_1_subtext[0] && _react2.default.createElement(_components.Text, {
	                    children: json.data.tile_1_subtext[0].text,
	                    fontSize: [2, 3],
	                    mb: 96
	                  }),
	                  json.data.tile_1_button_text && _react2.default.createElement(_components.PrimaryButton, {
	                    children: json.data.tile_1_button_text,
	                    is: _gatsbyLink2.default,
	                    to: "/" + this.props.pathContext.lang + json.data.tile_1_button_link
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _rebass.Box,
	              { is: "section", mb: [5, 6], mx: [-4, 0] },
	              _react2.default.createElement(
	                _components.CardLayout,
	                null,
	                _react2.default.createElement(_components.Card, { object: this.props.data.featured1 }),
	                _react2.default.createElement(_components.Card, { object: this.props.data.featured2 }),
	                _react2.default.createElement(_components.Card, { object: this.props.data.featured3 }),
	                _react2.default.createElement(_components.Card, { object: this.props.data.featured4 })
	              )
	            ),
	            _react2.default.createElement(
	              _rebass.Box,
	              { is: "section", mb: [5, 6] },
	              _react2.default.createElement(
	                _components.GradientCard,
	                {
	                  image: json.data.tile_2_image ? json.data.tile_2_image.half.url : ""
	                },
	                _react2.default.createElement(
	                  _rebass.Box,
	                  { w: [1, null, 1 / 2] },
	                  json.data.tile_2_small_title[0] && _react2.default.createElement(_components.H4, {
	                    children: json.data.tile_2_small_title[0].text,
	                    mb: 5
	                  }),
	                  json.data.tile_2_title[0] && _react2.default.createElement(_components.H2, {
	                    children: json.data.tile_2_title[0].text,
	                    mb: 5,
	                    fontSize: [4, 5]
	                  }),
	                  json.data.tile_2_button_text && _react2.default.createElement(_components.PrimaryButton, {
	                    children: json.data.tile_2_button_text,
	                    is: _gatsbyLink2.default,
	                    to: "/" + this.props.pathContext.lang + json.data.tile_2_button_link
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _rebass.Box,
	              { is: "section", mx: [-4, 0], pb: [0, 6] },
	              _react2.default.createElement(
	                _components.CardLayout,
	                null,
	                _react2.default.createElement(_components.Card, { object: this.props.data.featured5 }),
	                _react2.default.createElement(_components.Card, { object: this.props.data.featured6 }),
	                _react2.default.createElement(_components.Card, { object: this.props.data.featured7 }),
	                _react2.default.createElement(_components.Card, { object: this.props.data.featured8 })
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Home;
	}(_react2.default.Component);
	
	Home.contextTypes = {
	  setAltLanguages: _propTypes2.default.func
	};
	exports.default = Home;
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-home-page-js-1c895531dc060e735440.js